import { Component } from '@angular/core';
import { DeviceFactory } from '../../device/device-factory/device-factory';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-charging-fleet-reports',
	templateUrl: './charging-fleet-reports.component.html',
	styleUrls: ['./charging-fleet-reports.component.css']
})
export class ChargingFleetReportsComponent {
	siteSub: Subscription = new Subscription();
	chargerTypes = [
		DeviceFactory.types.brm,
		DeviceFactory.types.charglink,
	];

	powerUsageChartConfig = {
		title: this.translateService.instant('perf_analytic.charger_fleet_power_usage_charts'),
		ampChartTitle: this.translateService.instant('fleet_reports.chargers_amp_draw'),
		kwChartTitle: this.translateService.instant('fleet_reports.chargers_kw_draw'),
	}

	siteInfo: any = {};

	constructor(
		private translateService: TranslateService,
		private commonService: CommonService,
		private sideMenuService: SideMenuService
	){}

	ngOnInit() {
		this.siteSub = this.sideMenuService.currentSite.subscribe((site) => {
			if (!site || !site['id'])
				return;
			this.siteInfo = site;
			this.commonService.setPageTabTitle(`${site['customer_name']} - ${site['name']} - ${this.translateService.instant('fleet_reports.charger_fleet_reports')}`);
		});
	}

	ngOnDestroy() {
		if (this.siteSub)
			this.siteSub.unsubscribe();
	}
}
